<!--<div class="main-content">
    <div class="container-fluid">
        <div class="row" style="margin: auto;">
            <div class="card">
                <div class="card-header card-header-danger">
                    <h4 class="card-title">Visitor Manager</h4>
                </div>
                <div class="card-body">
                    <form [formGroup]="VisitorForm" #visitorForm="ngForm" (ngSubmit)="SubmitToDataBase();">
                        <fieldset>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div class="row">
                                        <div class="example-full-width">
                                            <input type="text" placeholder="Select Country Code" (focus)="getCountriesList()" (keyup)="getCountriesList()" formControlName="CountryCode" required [matAutocomplete]="cList">
                                            <mat-autocomplete #cList="matAutocomplete" [displayWith]="getCountryCode">
                                                <mat-option *ngFor="let clist of countriesList" [value]="clist">
                                                    {{clist.Country}}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="example-full-width">
                                            <input placeholder="Enter Mobile Number" (change)="getVisitorDetails();" type="number" formControlName="MobileNumber" autocomplete="off" required />

                                        </div>
                                    </div>
                                    <div *ngIf="RegisterVisitor">
                                        <div class="row">
                                            <div class="example-full-width">
                                                <input type="text" placeholder="Enter Name" formControlName="VisitorName" required>

                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="example-full-width">
                                                <input placeholder="Enter EmailID" type="email" formControlName="EmailID" autocomplete="off" required />

                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="example-full-width">
                                                <input type="password" placeholder="Enter Password" formControlName="Password" required>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <button mat-stroked-button color="primary" type="submit"><i class="fa fa-plus"></i>Add</button>
                                        </div>
                                    </div>
                                    <div *ngIf="VerifyOTP">
                                        <div class="row">
                                            Name:&nbsp; {{VisitorDetails.VisitorName}}
                                            EmailID: {{VisitorDetails.EmailID}}

                                        </div>
                                        <form #VerifyOTPForm="ngForm" (ngSubmit)="VerifyVisitorOTP(VerifyOTPForm);">
                                            <div class="row">
                                                <div class="example-full-width">
                                                    <input type="text" placeholder="Enter OTP" #OTP="ngModel" ngModel name="OTP" required />

                                                    <input type="hidden" id="VisitorHandle" [value]="VisitorDetails.VisitorHandle" />
                                                </div>
                                            </div>
                                            <div class="row">
                                                <button mat-stroked-button color="primary" type="submit"><i class="fa fa-plus"></i>Add</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>-->


<form [formGroup]="VisitorPhoneForm" *ngIf="IsInitialised">
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <h5>Country*</h5>
        <select (change)="OnSelectCountry($event)" formControlName="CountryID" class="form-control">
          <option *ngFor="let i of CountryList" [value]="i.DataValue">{{i.DataText}}</option>
        </select>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <h5>Mobile*</h5>
        <!--<span>{{VisitorPhoneForm.value.CountryCode}}</span>-->
        <input type="text" formControlName="MobileNumber" autocomplete="off" (keypress)="manikInteger($event)"
          (keyup)="CheckIfContactExists()" [maxlength]="maxlength" class="form-control">
        <span *ngIf="VisitorPhoneForm.controls.MobileNumber.dirty && VisitorPhoneForm.controls.MobileNumber.errors"
          class="text-danger">
          <span *ngIf="VisitorPhoneForm.controls.MobileNumber.errors.required">required</span>
          <span *ngIf="VisitorPhoneForm.controls.MobileNumber.errors.maxlength">
            Please enter a number with {{maxlength}}
            digits
          </span>
        </span>
      </div>
    </div>
  </div>
</form>
<manik-data-loader *ngIf="ShowLoader"></manik-data-loader>
<form [formGroup]="VisitorDetailsForm" *ngIf="ShowForm" #visitorForm="ngForm">
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <h5>Name</h5>
        <input type="text" class="form-control" placeholder="Enter your name" formControlName="VisitorName" />
      </div>
    </div>
  </div>
  <div class="row">
    <div [ngClass]="{'col-md-6': AskEmail, 'col-md-12': !AskEmail}">
      <div class="form-group">
        <h5>Email</h5>
        <input type="text" class="form-control" formControlName="EmailID" placeholder="Enter your email address" />
        <span *ngIf="submitted && VisitorDetailsForm.controls.EmailID.errors" class="text-danger">
          <span *ngIf="VisitorDetailsForm.controls.EmailID.errors.required"> {{EmailError}}</span>
        </span>
      </div>
    </div>
    <div class="col-md-6" *ngIf="AskEmail">
      <div class="form-group">
        <h5>Password</h5>
        <input type="password" class="form-control" formControlName="Password" placeholder="Enter your password" />
      </div>
    </div>
  </div>
  <div class="row" *ngIf="AskEmail">
    <div class="col-md-6">
      <div class="cManikVisitorAcceptTerms">
        <input type="checkbox" class="form-control" formControlName="OKToContactBack">
        <p>I authorize {{PortalName}} to contact me with the details provided</p>
      </div>
    </div>
  </div>
  <button class="cPortalSubmit" (click)="SubmitForm()" *ngIf="!submitted && AskEmail">Submit</button>
  <button class="btn btn-primary" *ngIf="submitted">
    <manik-button-loader></manik-button-loader>
  </button>
</form>


<app-otp-handler *ngIf="ShowVerifyOTP" [OTPHandle]="OTPHandle" (OTPVerified)="OTPVerified()"></app-otp-handler>